import React from "react";
import styles from "./CardList.module.css";

const SourceCardSkeleton: React.FC = () => {
  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <div
          className={styles.skeleton}
          style={{ width: "8.75rem", height: "1rem" }}
        />
      </div>
      <div className={styles.cardBody}>
        <div className={styles.cardRow}>
          <span className={styles.cardLabel}>Source:</span>
          <div
            className={styles.skeleton}
            style={{ width: "6.25rem", height: "0.875rem" }}
          />
        </div>
        <div className={styles.cardRow}>
          <span className={styles.cardLabel}>Providers:</span>
          <div
            className={styles.skeleton}
            style={{ width: "2.5rem", height: "0.875rem" }}
          />
        </div>
        <div className={styles.cardRow}>
          <span className={styles.cardLabel}>Tasks:</span>
          <div
            className={styles.skeleton}
            style={{ width: "2.5rem", height: "0.875rem" }}
          />
        </div>
      </div>
    </div>
  );
};

export default SourceCardSkeleton;
